module.exports = __webpack_public_path__ + "img/contentful_import_for_plugin_creation.72c261ea.png";